import { useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  H4,
  TextInput,
} from "@datapay-by-datacom/design-system";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";

interface ThreadRenameProps {
  threadTitle: string;
  workspaceId: string;
  threadId: string;
  onClose: () => void;
}

export function ThreadRename({
  threadTitle,
  workspaceId,
  threadId,
  onClose,
}: ThreadRenameProps) {
  const [title, setTitle] = useState(threadTitle);
  const queryClient = useQueryClient();

  const { mutate: updateTitle, isPending } = useMutation({
    mutationFn: async () => {
      await api.setThreadTitle(workspaceId, threadId, { title });
    },
    onSuccess: () => {
      // Invalidate both the thread list and the individual thread queries
      queryClient.invalidateQueries({
        queryKey: ["workspace", workspaceId, "thread"],
      });
      queryClient.invalidateQueries({
        queryKey: ["workspace", workspaceId, "thread", threadId],
      });
      onClose();
    },
  });

  return (
    <Card>
      <CardBody>
        <H4>Rename Thread</H4>
        <TextInput
          label="Thread Title"
          value={title}
          onInput={(evt) => setTitle(evt.currentTarget.value)}
          autoFocus
        />
      </CardBody>
      <CardFooter>
        <ButtonGroup>
          <Button variant="secondary" onPress={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onPress={() => updateTitle()}
            isDisabled={isPending || !title.trim() || title === threadTitle}
          >
            Save
          </Button>
        </ButtonGroup>
      </CardFooter>
    </Card>
  );
}
